(function () {
  function toFollowerThousands(value) {
    var count = Number.parseFloat(value);
    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function formatFollowerTotal(thousands) {
    var roundedThousands = Math.round(thousands * 10) / 10;

    if (roundedThousands >= 1000) {
      return String(Math.round((roundedThousands / 1000) * 10) / 10) + 'M';
    }

    return String(roundedThousands) + 'K';
  }

  function initializeLinkHub(root) {
    var counter = root.querySelector('[data-link-hub-follower-total]');

    if (counter) {
      var total = toFollowerThousands(counter.dataset.instagramFollowers)
        + toFollowerThousands(counter.dataset.tiktokFollowers);
      var formattedTotal = formatFollowerTotal(total);

      counter.textContent = formattedTotal;
      counter.setAttribute('aria-label', formattedTotal + ' followers');
    }

    window.requestAnimationFrame(function () {
      root.dataset.linkHubReady = 'true';
    });
  }

  function initialize() {
    document.querySelectorAll('[data-myron-link-hub]').forEach(initializeLinkHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
